import defaultsDeep from 'lodash/defaultsDeep';
import ObjectId from 'bson-objectid';

export default function QuestionTarget(values) {
  return defaultsDeep(values, {
    id: ObjectId().toHexString(),
    name: '',
  });
}
